// extracted by css-extract-rspack-plugin
export default {"container":"SubIssueTypeIndicator-module__container__X64fw3O"};